<template>
  <!-- 使用 van-popup 替代 el-dialog -->
  <van-popup v-model="open" position="bottom" :close-on-click-overlay="false" round closeable style="max-height: 90vh;">
    <div class="dialog-content detailsVant">
      <!-- 标题 -->
      <div class="dialog-header">
        <h3>{{ title }}</h3>
      </div>

      <!-- 全选 + 批量删除按钮 -->
      <div class="details-top">
        <van-checkbox v-model="checkAll" @change="handleCheckAllChange" :indeterminate="isIndeterminate">
          全选
        </van-checkbox>
        <van-button size="small" type="danger" @click="handleDelete(2)">批量删除</van-button>
      </div>

      <!-- 图片列表区域 -->
      <div class="face-database-list">
        <!-- 空状态 -->
        <van-empty description="暂无内容" v-if="detailsForm.length === 0" />

        <!-- 多选组 -->
        <van-checkbox-group v-model="checkedIds" @change="handleCheckedItemsChange"  class="detailsVant_checkboxgroup">
          
               <div  class="faceDatabase_box" v-for="item in detailsForm"
              :key="item.faceToken"
              clickable
              :border="true" >
              
         <div class="faceDatabase_box_imgBox">
          <image-preview :src="item.url" :width="100" :height="100" />
          <!-- <img :src="item.url" class="faceDatabase_box_img" alt="" /> -->
        </div>
        <span class="faceDatabase_box_name">{{ item.createUser }}</span>
        <span class="faceDatabase_box_time">{{ item.createTime }}</span>
        <div class="faceDatabase_box_btnBox">
          <van-checkbox :name="item.faceToken" @click.stop  class="detailsVant_checkbox"></van-checkbox>
          <el-button
            size="mini"
            type="danger"
            round
            plain
            @click.stop="handleDelete(1,item)"
            >删除</el-button
          >
        </div>
       </div>
        </van-checkbox-group>
      </div>

      <!-- 按钮底部 -->
      <div class="dialog-footer">
        <van-button block @click="cancel">关闭</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { faceLibraryImg, faceLibrarydelFace } from "@/api/faceDatabase";
import "@/assets/imgList.css";

export default {
  components: {},
  data() {
    return {
      title: "",
      open: false,
      btnShow: false,
      detailsNum: 3,
      detailsForm: [],
      id: null,
      checkedIds: [], // 选中的 faceToken 列表
      checkAll: false,
      isIndeterminate: false,
    };
  },
  methods: {
    addCreateForm(record) {
      this.open = true;
      this.title = "详情";
      this.id = record.id;
      this.getImgFun();
    },
    getImgFun() {
      faceLibraryImg({ libraryId: this.id }).then((response) => {
        this.detailsForm = response.data.data || [];
      });
    },
    handleDelete(type, row) {
      const id = this.id;
      let faceTokenList = [];

      if (type === 1) {
        faceTokenList.push(row.faceToken);
      } else if (type === 2) {
        faceTokenList = this.checkedIds;
      }

      if (faceTokenList.length === 0) {
        this.$toast.fail("请选择要删除的图片");
        return;
      }

      this.$dialog.confirm({
        title: "确认删除",
        message: "是否确认删除所选图片？",
      })
        .then(() => {
          return faceLibrarydelFace({
            id: id,
            faceToken: faceTokenList,
          });
        })
        .then(() => {
          this.getImgFun();
          this.checkAll = false;
          this.isIndeterminate = false;
          this.checkedIds = [];
          this.$toast.success("删除成功");
        })
        .catch(() => {
          // 取消或失败
        });
    },
    cancel() {
      this.open = false;
    },
    handleCheckAllChange(value) {
      this.checkedIds = value ? this.detailsForm.map(item => item.faceToken) : [];
      this.isIndeterminate = false;
    },
    handleCheckedItemsChange(value) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.detailsForm.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.detailsForm.length;
    },
  },
};
</script>

<style scoped>
.faceDatabase_box{
      width: 42%;
    min-width: 120px;
    margin-right: 4%;
    margin-bottom: 20px;
    /* border: 1px solid #ccc; */
    padding: 10px;
    border-radius: 5px;
    display: flex
;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-image: url(https://beauty-hair.oss-cn-beijing.aliyuncs.com/hairImg/bee0.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: relative;
}
.faceDatabase_box:nth-child(2n){
  margin-right: 0;
}
.dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 14px;
  background-color: #fff;
  border-radius: 16px 16px 0 0;
}

.dialog-header {
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid #f2f2f2;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.details-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #f9f9f9;
  border-bottom: 1px solid #eaeaea;
}

.face-database-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.face-database-item {
  padding: 12px 0;
}

.face-database-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.img-box {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  background: linear-gradient(151deg, #c1d7fd 0%, #dbc7fe 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.info {
  flex: 1;
  min-width: 0;
}

.name {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.time {
  display: block;
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.btn-box {
  flex-shrink: 0;
}

.dialog-footer {
  padding: 12px 16px 20px;
  background-color: #fff;
  border-top: 1px solid #f2f2f2;
}
.detailsVant_checkboxgroup{
display: flex;
flex-wrap: wrap;
padding: 0 10px;
}
.detailsVant_checkbox{
  margin-right: 10px;
}
</style>
<style>
</style>